<p-dialog
    [visible]="visible"
    (visibleChange)="onVisibleChange($event)"
    header="Lot and stock details"
    [modal]="true"
    [closable]="true"
    styleClass="stock-lots-dialog"
    [style]="{ width: '860px' }"
    [contentStyle]="{ overflow: 'hidden', padding: '0.65rem 0.85rem 0.75rem' }"
    [breakpoints]="{ '900px': '94vw', '640px': '100vw' }"
    appendTo="body"
>
    <div class="stock-lots-modal">
        <div class="stock-lots-toolbar">
            <p-autoComplete
                class="stock-lots-item-input"
                [ngModel]="selectedSuggestion"
                (ngModelChange)="onSearchModelChange($event)"
                [suggestions]="suggestions"
                [minLength]="3"
                [delay]="400"
                [forceSelection]="true"
                [dropdown]="false"
                field="FINALRESPNSE"
                placeholder="Search item name or number"
                appendTo="body"
                (completeMethod)="searchItems($event)"
                (onSelect)="onItemSelected($event)"
                (onClear)="onSuggestionCleared()"
            ></p-autoComplete>
            <span *ngIf="warehouse" class="stock-lots-wh">WH {{ warehouse }}</span>
        </div>
        <div class="stock-lots-hint" [class.is-loading]="searchingItems || loadingLots">
            {{ searchHint || 'M3 lot stock. Torna usage is not deducted until sync.' }}
        </div>

        <div class="stock-lots-grid" [class.is-loading]="loadingLots">
            <p-table
                [value]="lots"
                dataKey="lot"
                [scrollable]="true"
                scrollHeight="280px"
                styleClass="p-datatable-sm"
            >
                <ng-template pTemplate="header">
                    <tr>
                        <th>Expiry</th>
                        <th>Lot</th>
                        <th>Location</th>
                        <th>Status</th>
                        <th class="col-num">On hand</th>
                        <th class="col-num">Available</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr [class.stock-lots-latest]="row.latestExpiry">
                        <td>{{ row.expiryDate || '-' }}</td>
                        <td>{{ row.lot || '-' }}</td>
                        <td>{{ row.location || '-' }}</td>
                        <td>{{ row.status || '-' }}</td>
                        <td class="col-num">{{ row.onHandQty | number: '1.0-2' }}</td>
                        <td class="col-num">{{ row.availableQty | number: '1.0-2' }}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="6">{{ loadingLots ? 'Loading lots…' : errorMessage || (selectedItemNo ? 'No lots found.' : 'Select an item to view lots.') }}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>

        <div *ngIf="result && lots.length" class="stock-lots-footer">
            <span>Available on earliest expiry ({{ result.latestExpiryDate || '-' }}): <strong>{{ result.latestExpiryAvailableQty | number: '1.0-2' }}</strong></span>
            <span>All lots available: <strong>{{ result.totalAvailableQty | number: '1.0-2' }}</strong></span>
        </div>
        <div *ngIf="errorMessage && lots.length" class="stock-lots-error">{{ errorMessage }}</div>
    </div>
</p-dialog>
